import { Badge } from '@chakra-ui/react';

import { placementStatusMetadata } from './constants';

// Re-exported so consumers can reach the metadata via the externally-resolvable
// `.tsx` entrypoint (the package only maps `./components/*` to `.tsx` files).
export { placementStatusMetadata } from './constants';

export function PlacementStatusBadge({
  status,
  onHold = false,
}: {
  status: keyof typeof placementStatusMetadata;
  onHold?: boolean;
}): React.ReactElement {
  // On-hold is a separate boolean flag on the placement, not a status. When set it
  // takes precedence over the underlying status (mirrors the work-placement drawer).
  const { label, color, variant } = onHold
    ? { label: 'On hold', color: 'gray', variant: 'outline' }
    : placementStatusMetadata[status];

  return (
    <Badge
      fontSize="xs"
      fontWeight="bold"
      borderRadius="full"
      colorScheme={color}
      variant={variant}
      textTransform="none"
      whiteSpace="nowrap"
    >
      {label}
    </Badge>
  );
}
